import React from "react";

export const Check = ({ color = "black", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color }}
    >
      <g id="check">
        <path
          id="Vector"
          d="M5.24994 12.4117L1.62744 8.78918L3.27827 7.13835L5.24994 9.11585L11.0133 3.34668L12.6641 4.99751L5.24994 12.4117Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
